import { render, staticRenderFns } from "./isMyDataPrivateCard.vue?vue&type=template&id=7fa06d54&scoped=true&"
import script from "./isMyDataPrivateCard.vue?vue&type=script&lang=js&"
export * from "./isMyDataPrivateCard.vue?vue&type=script&lang=js&"
import style0 from "./isMyDataPrivateCard.vue?vue&type=style&index=0&id=7fa06d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa06d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa06d54')) {
      api.createRecord('7fa06d54', component.options)
    } else {
      api.reload('7fa06d54', component.options)
    }
    module.hot.accept("./isMyDataPrivateCard.vue?vue&type=template&id=7fa06d54&scoped=true&", function () {
      api.rerender('7fa06d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/isMyDataPrivateCard.vue"
export default component.exports